module.exports = __webpack_public_path__ + "91ac6c9a4605eea0a5e37319c33209f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/POS-2-09.png
// module id = 732
// module chunks = 0